import React from 'react';
import { Gamepad2 } from 'lucide-react';

export const HeroSection: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="flex items-center gap-4 mb-4">
        <div className="p-4 bg-blue-600 rounded-2xl shadow-lg shadow-blue-600/20">
          <Gamepad2 size={48} className="text-white" />
        </div>
        <div>
          <h2 className="text-3xl font-bold text-white">
            PixiJS Editor
          </h2>
          <p className="text-gray-400 text-lg mt-1">
            Professional 2D Game Development
          </p>
        </div>
      </div>
      <p className="text-blue-400 text-lg font-medium tracking-wide">
        Build. Create. Publish.
      </p>
    </div>
  );
};
